export default "__VITE_ASSET__JBTLWzcF__$_?inline__"